<template>
  <div
    class="row flex"
    id="Utilisateur_ModifierPointRelaisFavoris_List"
    v-if="parcelshopList.length"
  >
    <div class="col-sm-5 pr-0">
      <div
        class="panel left-panel"
        :class="{ 'panel-closed': isPanelClosed, details: hasFocus }"
      >
        <QrCodeSelectionCard v-if="displayQRCodeSelectionCard && !hasFocus" />
        <LockerSelectionCard v-if="displayLockerSelectionCard && !hasFocus" />
        <div
          v-show="displayPrintInStoreWarningMessage"
          id="print-in-store-no-available-pr-message"
        >
          <p>{{ $t("parcelshopPicker.parcelshopList.noDataMessage.oops") }}</p>
          <p>
            <b>{{
              $t("parcelshopPicker.parcelshopList.noDataMessage.printYourself")
            }}</b>
            {{
              $t("parcelshopPicker.parcelshopList.noDataMessage.instruction")
            }}
          </p>
        </div>
        <div
          class="center bar-back close-detail"
          v-show="hasFocus"
          tabindex="0"
          @click="clearFocusParcelshop()"
          @keydown.enter.prevent="clearFocusParcelshop()"
          @keydown.space.prevent="clearFocusParcelshop()"
        >
          <!-- <span class="icon-arrow-left2 f-left"></span> -->
          <svg
            class="icon-arrow-left2 f-left"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="14"
            height="14"
            viewBox="0 0 16 16"
          >
            <path
              d="M6.293 13.707l-5-5c-0.391-0.39-0.391-1.024 0-1.414l5-5c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-3.293 3.293h9.586c0.552 0 1 0.448 1 1s-0.448 1-1 1h-9.586l3.293 3.293c0.195 0.195 0.293 0.451 0.293 0.707s-0.098 0.512-0.293 0.707c-0.391 0.391-1.024 0.391-1.414 0z"
            ></path>
          </svg>
          {{ $t("parcelshopPicker.parcelshopList.back") }}
          <!-- <span class="icon-cross f-right"></span> -->
          <svg
            class="icon-cross f-right"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="14"
            height="14"
            viewBox="0 0 16 16"
          >
            <path
              d="M15.854 12.854c-0-0-0-0-0-0l-4.854-4.854 4.854-4.854c0-0 0-0 0-0 0.052-0.052 0.090-0.113 0.114-0.178 0.066-0.178 0.028-0.386-0.114-0.529l-2.293-2.293c-0.143-0.143-0.351-0.181-0.529-0.114-0.065 0.024-0.126 0.062-0.178 0.114 0 0-0 0-0 0l-4.854 4.854-4.854-4.854c-0-0-0-0-0-0-0.052-0.052-0.113-0.090-0.178-0.114-0.178-0.066-0.386-0.029-0.529 0.114l-2.293 2.293c-0.143 0.143-0.181 0.351-0.114 0.529 0.024 0.065 0.062 0.126 0.114 0.178 0 0 0 0 0 0l4.854 4.854-4.854 4.854c-0 0-0 0-0 0-0.052 0.052-0.090 0.113-0.114 0.178-0.066 0.178-0.029 0.386 0.114 0.529l2.293 2.293c0.143 0.143 0.351 0.181 0.529 0.114 0.065-0.024 0.126-0.062 0.178-0.114 0-0 0-0 0-0l4.854-4.854 4.854 4.854c0 0 0 0 0 0 0.052 0.052 0.113 0.090 0.178 0.114 0.178 0.066 0.386 0.029 0.529-0.114l2.293-2.293c0.143-0.143 0.181-0.351 0.114-0.529-0.024-0.065-0.062-0.126-0.114-0.178z"
            ></path>
          </svg>
        </div>
        <div
          class="scroll-bar-wrap scroll-box"
          :class="{
            'no-print-in-store':
              !displayQRCodeSelectionCard && !displayLockerSelectionCard,
          }"
        >
          <ParcelshopCard
            :price="parcelshopPrices[parcelshop.Numero] || price"
            :numeroUnavailableParcelshop="numeroUnavailableParcelshop"
            v-for="(parcelshop, index) in parcelshopList"
            :key="parcelshop.Numero"
            :parcelshop="parcelshop"
            :parcelshopNumber="index + 1"
            class="panel-item"
            @parcelshop-selected="ascendEvent"
          />
        </div>
        <div class="center nb-results" v-show="!hasFocus">
          <b>{{ parcelshopList.length }}</b
          >&nbsp;{{ $t("parcelshopPicker.parcelshopList.results") }}
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-7 pl-0 map-container right-panel hidden-xs">
      <ParcelshopMap
        ref="mapComponent"
        class="the-map"
        :parcelshopList="parcelshopList"
        @parcelshopSelected="openPanel"
      />
      <div class="map-bloc">
        <div class="lister" id="IconListerPCL" v-if="!hasFocus">
          <!-- <span class="icon-lister" @click="switchPanelVisibility"></span> -->
          <span class="icon-lister" @click="switchPanelVisibility">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="33"
              height="33"
              viewBox="0 0 16 16"
            >
              <path
                d="M0 0h4v4h-4zM6 1h10v2h-10zM0 6h4v4h-4zM6 7h10v2h-10zM0 12h4v4h-4zM6 13h10v2h-10z"
              ></path>
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div v-else>{{ $t("parcelshopPicker.parcelshopList.noResult") }}</div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import { mapGetters } from "vuex";
import ParcelshopMap from "../ParcelshopMap/ParcelshopMap";
import ParcelshopCard from "../ParcelshopCard/ParcelshopCard";
import QrCodeSelectionCard from "../QrCodeSelectionCard/QrCodeSelectionCard";
import LockerSelectionCard from "../LockerSelectionCard/LockerSelectionCard";
import { getLockerNatures } from "../../utils/amazonLocker";

export default {
  props: {
    numeroUnavailableParcelshop: {
      type: Number,
      required: false,
      default: 0,
    },
    price: null,
  },
  components: {
    ParcelshopMap,
    ParcelshopCard,
    QrCodeSelectionCard,
    LockerSelectionCard,
  },
  data() {
    return {
      isPanelClosed: true,
      tarifs: "",
      parcelshopPrices: {},
    };
  },
  mounted() {
    this.isPriceNeeded();
  },
  watch: {
    parcelshopList() {
      this.$nextTick(() => {
        this.isPriceNeeded();
      });
    },
  },
  computed: {
    ...mapGetters(["parcelshopList"]),
    isPriceModeEnabled: function () {
      return this.$store.state.params.isPriceModeEnabled;
    },
    hasFocus: function () {
      return this.$store.state.focusedParcelshopId != null;
    },
    displayQRCodeSelectionCard: function () {
      return (
        this.$store.state.showFilterPrintInStore &&
        this.$store.state.isCountryPrintInStore
      );
    },
    displayLockerSelectionCard: function () {
      return (
        this.$store.state.showFilterLocker &&
        this.$store.state.authorizedNatures.includes("C")
      );
    },
    displayPrintInStoreWarningMessage: function () {
      if (!this.displayQRCodeSelectionCard) {
        return false;
      }

      return !(
        this.parcelshopList &&
        this.parcelshopList.some(
          (e) => e.Services && e.Services.some((e) => e.Code === "PRINT")
        )
      );
    },
  },
  methods: {
    clearFocusParcelshop: function () {
      this.isPanelClosed = true;
      this.$store.dispatch("focusParcelshop", { parcelshopId: null });
    },
    switchPanelVisibility: function () {
      this.isPanelClosed = !this.isPanelClosed;
    },
    openPanel: function () {
      this.isPanelClosed = false;
    },
    ascendEvent: function (parselshop) {
      let pclId = document.querySelector("#ECommerce_Livraison_PCL_ID");
      if (pclId) {
        document.querySelector("#ECommerce_Livraison_PCL_ID").value =
          parselshop.Adresse.Pays.Code + "-" + parselshop.Numero;
      }

      let formInputPayCode = document.querySelector(
        "#ECommerce_Livraison_PCL_PAY_CODE"
      );
      if (formInputPayCode) {
        formInputPayCode.value = parselshop.Adresse.Pays.Code;
      }

      this.$emit("parcelshop-selected", parselshop);
    },

    isPriceNeeded() {
      if (this.isPriceModeEnabled) {
        const modeLivraisonDOM = document.querySelector("#modeLivraisonDom");
        if (
          !modeLivraisonDOM ||
          !modeLivraisonDOM.classList.contains("selected")
        ) {
          this.triggerPriceFinding();
        }
      }
    },

    determinerTarifPointRelais() {
      let recepteurPays = document.querySelector("#recepteurPays").value;
      let tarifsFiltresParPays = this.filtrerTarifs(recepteurPays);
      if (tarifsFiltresParPays != undefined && tarifsFiltresParPays != null) {
        this.tarifs = this.obtenirTarifPointRelais(tarifsFiltresParPays);
        this.parcelshopPrices = {};
        let listePointRelais = document.querySelectorAll(".card-body");
        let nature;
        listePointRelais.forEach((pointRelais, pointRelaisIndex) => {
          nature = pointRelais.getAttribute("data-codeNature");
          let prix;
          for (let index = 0; index < this.tarifs.length; index++) {
            let tarif = this.tarifs[index];
            if (tarif.getAttribute("data-CodeNature").indexOf(nature) !== -1) {
              pointRelais.setAttribute(
                "data-tarifid",
                tarif.getAttribute("data-id")
              );
              prix = tarif.getAttribute("data-prix");
              break;
            }
          }
          if (prix != undefined) {
            let montant = parseFloat(prix.replace("€", "").replace(",", "."))
              .toFixed(2)
              .replace(".", ",");
            const parcelshop = this.parcelshopList[pointRelaisIndex];
            if (parcelshop) {
              this.$set(this.parcelshopPrices, parcelshop.Numero, montant);
            }
          }
        });
        this.$refs.mapComponent.reloadMap();
      }
    },
    resetZoomMap() {
      this.$refs.mapComponent.resetZoom();
    },

    obtenirTarifPointRelais(tarifs) {
      const naturesLocker = getLockerNatures(
        document.querySelector("#recepteurPays").value
      );
      // J hors de France reste une nature de relais classique
      const codenatureFiltre = ["1", "A", "D", "E", "F", "S", "T"].concat(
        naturesLocker.includes("J") ? [] : ["J"]
      );
      const modeLivraisonLCK = document.querySelector("#modeLivraisonLCK");
      const modeLivraisonLCKSelected =
        modeLivraisonLCK && modeLivraisonLCK.classList.contains("selected");

      const codenaturePrioritaire = modeLivraisonLCKSelected
        ? naturesLocker
        : codenatureFiltre;
      const selectedId = modeLivraisonLCKSelected
        ? "#modeLivraisonLCK"
        : "#modeLivraisonPCL";

      let tarifPCL = Array.from(tarifs).filter((tarif) => {
        const codenatureListe = tarif
          .getAttribute("data-codenature")
          .split(";");
        const intersection = codenaturePrioritaire.filter((cn) =>
          codenatureListe.includes(cn)
        );

        return (
          tarif.getAttribute("data-codetypelivraison") ===
            window.codeLivraisonRelais && intersection.length > 0
        );
      });

      if (!tarifPCL.length) {
        return [];
      }

      let listePrix = tarifPCL.map((tarif) =>
        parseFloat(tarif.getAttribute("data-Prix").replace(",", ".").replace("€", ""))
      );
      let tarifmin = Math.min(...listePrix);
      const selectedModeLivraison = document.querySelector(selectedId);
      const tarifElement = selectedModeLivraison
        ? selectedModeLivraison.querySelector(".tarif")
        : null;
      const tarifRecap = document.querySelector("#TarifRecap");
      let tarifAffiche = tarifElement
        ? tarifElement.getAttribute("data-tarifAffiche")
        : null;

      if (tarifAffiche === null || tarifAffiche === undefined) {
        tarifAffiche = tarifRecap
          ? tarifRecap.getAttribute("data-tarifAfficheRecap")
          : "";
      }

      tarifAffiche = tarifAffiche || "";

      const otIndemnityElement = document.getElementById("otIndemnity");
      const otIndemnity = otIndemnityElement ? otIndemnityElement.value : "";

      if (tarifElement) {
        tarifElement.innerHTML =
          tarifAffiche + tarifmin.toFixed(2).replace(".", ",") + " €";
      }

      if (otIndemnity && tarifRecap) {
        const otIndemnityValue = parseFloat(
          otIndemnity.replace(/[^\d.-]/g, "")
        );

        tarifRecap.innerHTML =
          tarifAffiche +
          tarifmin.toFixed(2).replace(".", ",") +
          otIndemnityValue +
          " €";
      }

      const hdTarifAffranchissementPCLId = document.querySelector(
        "#hdTarifAffranchissementPCLId"
      );
      const tarifAffranchissementId = document.querySelector(
        "#tarifAffranchissementId"
      );

      if (hdTarifAffranchissementPCLId) {
        hdTarifAffranchissementPCLId.value = tarifPCL[0].getAttribute("data-id");
      }

      if (tarifAffranchissementId) {
        tarifAffranchissementId.value = tarifPCL[0].getAttribute("data-id");
      }

      return tarifPCL;
    },

    filtrerTarifs(pays) {
      let doublePoids = parseFloat(
        document.querySelector("#recepteurPoids").value.replace(",", ".")
      );
      let doubleDeveloppe = 0;
      if (!isNaN(doublePoids) && !isNaN(doubleDeveloppe)) {
        document.querySelector("#PoidsRecap").innerHTML = doublePoids + " kg";
        let tarifs = Array.from(document.querySelectorAll("#tarifs span"))
          .filter(
            (span) => span.getAttribute("data-poidsMax") >= doublePoids * 1000
          )
          .filter(
            (span) => span.getAttribute("data-developpemax") >= doubleDeveloppe
          )
          .filter((span) => span.getAttribute("data-payslivraison") === pays)
          .filter(
            (span) =>
              span.getAttribute("data-CodeFormatColis") ===
                document.querySelector("#recepteurFormatColis").value ||
              span.getAttribute("data-CodeFormatColis") === ""
          );
        return tarifs;
      } else {
        // document.querySelector("#CreerEnvoi_ModeLivraison").removeClass("open").slideUp();
      }
    },

    determinerAssurances(tarifSelectionne, comboAssuranceId) {
      var assurances = Array.from(tarifSelectionne.querySelectorAll("span"));

      if (assurances.length > 0) {
        var selectAssurancesPCL = document
          .querySelector("#" + comboAssuranceId)
          .innerHTML("");

        assurances.forEach((assurance) => {
          var option = new Option();
          option.value = assurance.getAttribute("assurance-id");
          option.text = assurance.getAttribute("assurance-libelle");
          option.setAttribute(
            "assurance-prix",
            assurance.getAttribute("assurance-prix")
          );
          selectAssurancesPCL.append(option);
        });
      } else {
        document.querySelector("#" + comboAssuranceId).hide();
      }
    },

    triggerPriceFinding() {
      const self = this;
      let weight = document.querySelector("#poids");
      if (weight != null && weight != undefined) {
        self.determinerTarifPointRelais();
        weight.addEventListener("input", function () {
          self.determinerTarifPointRelais();
        });
      }

      const deliveryModeRadios = document.querySelectorAll(
        'input[type="radio"][name="ModeLivraison.TypeLivraison"][value="PCL"]'
      );

      deliveryModeRadios.forEach((radio) => {
        radio.addEventListener("change", function () {
          self.isPriceNeeded();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bar-back {
  position: sticky;
  top: 0px;
  height: 40px;
  font-weight: normal;
  padding: 10px;

  cursor: pointer;

  z-index: 2;

  transition: all 0.2s, top 0s, left 0s, width 0s, height 0s;
  -moz-transition: all 0.2s, top 0s, left 0s, width 0s, height 0s;
  -webkit-transition: all 0.2s, top 0s, left 0s, width 0s, height 0s;
  -o-transition: all 0.2s, top 0s, left 0s, width 0s, height 0s;
  -ms-transition: all 0.2s, top 0s, left 0s, width 0s, height 0s;

  .icon-arrow-left2 {
    width: 14px;
    height: 14px;
  }

  .icon-cross {
    width: 14px;
    height: 14px;
  }
}

.nb-results {
  font-weight: normal;
  line-height: 40px;
  height: 40px;
  background-color: #fff;
}

.panel {
  // height: 100%;
  background-color: #fff;
}

.panel .flex {
  flex: 1;
}

.new .scroll-box {
  height: 535px;
}
.new .scroll-box.no-print-in-store,
.new .details .scroll-box {
  height: 605px;
}

.map-bloc {
  display: none;
}

.map-container {
  padding-right: 15px !important;
}

.new .container .map-bloc div.lister {
  background-color: #4dc1be;
  border-color: #4dc1be;
  padding: 2px;
}
.new .container .map-bloc div.lister span.icon-lister {
  svg {
    fill: #fff;
    color: #fff;
  }
}

.new .container .map-bloc div.lister span.icon-lister::before {
  content: "";
}

// @media (min-width: 768px) {
//   .flex {
//     display: flex;
//   }
// }

.flex {
  display: flex;
}

.left-panel,
.right-panel {
  flex: 1;
  position: relative;
}

@media (max-width: 767.98px) {
  .map-container {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  .new .scroll-box {
    height: calc(100% - 110px);
  }

  .new .scroll-box.no-print-in-store,
  .new .details .scroll-box {
    height: calc(100% - 30px);
  }

  .new .hidden-xs {
    display: block !important;
  }

  .map-bloc {
    display: block;

    div.lister {
      right: 40px !important;
      bottom: 50px !important;
    }
  }

  .panel {
    display: block;
    position: absolute;
    left: 0px;
    padding-left: 0;
    z-index: 1001;
    height: 90vh;
    width: 94vw;

    &.details {
      background-color: white;
      padding: 0 0 10px 15px;
      .panel-item {
        width: 100%;
        .table-horraire {
          margin-left: 20px;
        }
      }
    }
  }

  .card-body {
    padding-left: 40px;
  }

  .panel-closed {
    display: none;
  }

  .panel-item {
    padding-left: 10px;
  }

  .map-container {
    height: 90vh;
    overflow: hidden;
    & .the-map {
      height: 100%;
    }
  }

  .flex {
    display: block;
  }
}
</style>
